import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  hero1, hero2, logoBekasi, logoEbphtb,logoInstagram,logoPembebasan,wbs,
  logoEsptpd, logoSimpad, ipbb, lpse,
} from "../../assets";
import useDocumentTitle from "../../assets/utils/useDocumentTitle";
import { Footer, Header, SubFooter } from "../../components";
import BaseURL from "../../assets/utils/baseUrl";
import {
  Chart as ChartJS, CategoryScale, LinearScale, BarElement,
  ArcElement, Title, Tooltip, Legend,
} from "chart.js";
import { Bar, Pie } from "react-chartjs-2";
import YouTube from "react-youtube";
import "./style.scss";

ChartJS.register(CategoryScale, LinearScale, BarElement, ArcElement, Title, Tooltip, Legend);

/* ─── Tiny icon components ─────────────────────────────────────── */
const IconPlay   = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>;
const IconArrow  = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>;
const IconCalendar = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>;
const IconChart  = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>;

/* ─── Number formatter ─────────────────────────────────────────── */
const formatIDR = (x) =>
  new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR", maximumFractionDigits: 0 }).format(x);

/* ══════════════════════════════════════════════════════════════════
   BERANDA
══════════════════════════════════════════════════════════════════ */
const Beranda = () => {
  useDocumentTitle("BAPENDA - Kota Bekasi");

  const [slideIndex, setSlideIndex] = useState(0);
  const [banner, setBanner]         = useState([]);
  const [berita, setBerita]         = useState([]);
  const [agenda, setAgenda]         = useState([]);
  const [beritaVideo, setBeritaVideo] = useState([]);
  const [youtubePlay, setYoutubePlay] = useState({});
  const [chartActive, setChartActive] = useState("PAD");
  const [pajak, setPajak]   = useState({ all:[], label:[], target:[], realisasi:[] });
  const [retribusi, setRetribusi] = useState({ all:[], label:[], target:[], realisasi:[] });
  const [pad, setPad] = useState({ tahun:"", label:[], pajak_daerah:0, retribusi_daerah:0, kd_yang_dipisahkan:0, lain_lain_pad:0 });
  const [mounted, setMounted] = useState(false);

const secureUrl = (url) => {
  if (!url) return "";

  return url.replace("http://", "https://");
};

/* ───────────────── FETCH DATA FINAL FIX ───────────────── */

useEffect(() => {
  setMounted(true);

  const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
    "x-api-key": process.env.REACT_APP_API_KEY || "",
  };

  const fetchJSON = async (endpoint) => {
    try {
      const response = await fetch(
        `${BaseURL}${endpoint}`,
        {
          method: "GET",
          headers,
        }
      );

      if (!response.ok) {
        throw new Error(
          `HTTP ${response.status} - ${endpoint}`
        );
      }

      const text = await response.text();

      try {
        return JSON.parse(text);
      } catch (e) {
        return null;
      }
    } catch (err) {
      return null;
    }
  };

  const fetchData = async () => {
    try {
      /* ───────── BANNER ───────── */
      const bannerJson = await fetchJSON("index.php/api/Banner?jumlah_item=5");

      const bannerData = Array.isArray(bannerJson?.data)
        ? bannerJson.data
        : Array.isArray(bannerJson)
        ? bannerJson
        : [];

      // Sanitasi URL thumbnail & link agar selalu https dan aman
      const bannerSanitized = bannerData.map((b) => ({
        ...b,
        thumbnail: b?.thumbnail ? secureUrl(b.thumbnail) : null,
        link: b?.link && /^https?:\/\//i.test(b.link) ? secureUrl(b.link) : "#",
      }));

      setBanner(bannerSanitized);

      /* ───────── BERITA ───────── */
      const beritaJson = await fetchJSON(
        "index.php/api/Berita?jumlah_item=4"
      );

      if (Array.isArray(beritaJson?.data)) {
        setBerita(beritaJson.data);
      } else if (Array.isArray(beritaJson)) {
        setBerita(beritaJson);
      } else {
        setBerita([]);
      }

      /* ───────── AGENDA ───────── */
      const agendaJson = await fetchJSON(
        "index.php/api/Agenda?jumlah_item=4"
      );

      if (Array.isArray(agendaJson?.data)) {
        setAgenda(agendaJson.data);
      } else if (Array.isArray(agendaJson)) {
        setAgenda(agendaJson);
      } else {
        setAgenda([]);
      }

      /* ───────── VIDEO ───────── */
      const videoRes = await fetch(
  BaseURL + "index.php/api/Berita_video?jumlah_item=5",
  {
    method: "GET",
    headers,
  }
);

const videoJson = await videoRes.json();

      let videoData = [];

      if (Array.isArray(videoJson?.data)) {
        videoData = videoJson.data;
      } else if (Array.isArray(videoJson)) {
        videoData = videoJson;
      }

      setBeritaVideo(videoData);

      if (videoData.length > 0) {
        setYoutubePlay(videoData[0]);
      }

      /* ───────── PAJAK ───────── */
      const pajakJson = await fetchJSON(
        "index.php/api/Pajak?jumlah_item=5"
      );

      if (Array.isArray(pajakJson?.data)) {
        makePajak(pajakJson.data, setPajak);
      } else if (Array.isArray(pajakJson)) {
        makePajak(pajakJson, setPajak);
      }

      /* ───────── RETRIBUSI ───────── */
      const retribusiJson = await fetchJSON(
        "index.php/api/Retribusi?jumlah_item=5"
      );

      if (Array.isArray(retribusiJson?.data)) {
        makePajak(
          retribusiJson.data,
          setRetribusi
        );
      } else if (Array.isArray(retribusiJson)) {
        makePajak(
          retribusiJson,
          setRetribusi
        );
      }

      /* ───────── PAD ───────── */
      const padJson = await fetchJSON(
        "index.php/api/Pad?jumlah_item=1"
      );

      if (Array.isArray(padJson?.data)) {
        setPadArr(padJson.data);
      } else if (Array.isArray(padJson)) {
        setPadArr(padJson);
      }

    } catch (err) {
      // error fetch global — tidak di-expose ke user/console di production
    }
  };

  fetchData();

  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
}, []);

/* ───────────────── HELPERS FINAL FIX ───────────────── */

const makePajak = (res, setter) => {
  const arr = Array.isArray(res?.data)
    ? res.data
    : Array.isArray(res)
    ? res
    : [];

  if (!arr.length) {
    setter({
      all: [],
      label: [],
      target: [],
      realisasi: [],
    });
    return;
  }

  setter({
    all: arr,
    label: arr.map((i) => i.tahun ?? "-"),
    target: arr.map((i) => Number(i.target ?? 0)),
    realisasi: arr.map((i) => Number(i.realisasi ?? 0)),
  });
};

const setPadArr = (arr) => {
  if (!Array.isArray(arr)) return;
  if (arr.length === 0) return;

  const p = arr[0];

  setPad({
    tahun: p?.tahun || "-",
    label: [
      "Pajak Daerah",
      "Retribusi Daerah",
      "Kekayaan Daerah Dipisahkan",
      "Lain-lain PAD",
    ],

    pajak_daerah: Number(
      p?.pajak_daerah || 0
    ),

    retribusi_daerah: Number(
      p?.retribusi_daerah || 0
    ),

    kd_yang_dipisahkan: Number(
      p?.kd_yang_dipisahkan || 0
    ),

    lain_lain_pad: Number(
      p?.lain_lain_pad || 0
    ),
  });
};

 
  /* ── AUTO SLIDE BANNER ── */
useEffect(() => {
  // jika banner kosong
  if (!Array.isArray(banner) || banner.length === 0) return;

  const interval = setInterval(() => {
    setSlideIndex((prev) => {
      // reset ke awal jika sudah terakhir
      if (prev >= banner.length - 1) {
        return 0;
      }

      return prev + 1;
    });
  }, 5000);

  // cleanup
  return () => clearInterval(interval);

}, [banner]);

/* ── HISTATS ── */

useEffect(() => {
  window._Hasync = window._Hasync || [];
   window._Hasync.push(['Histats.start', '1,4600114,4,28,115,60,00011000']);
  window._Hasync.push(['Histats.fasi', '1']);
  window._Hasync.push(['Histats.track_hits', '']);

  const script = document.createElement("script");
  script.src = "https://s10.histats.com/js15_as.js";
  script.async = true;

  document.body.appendChild(script);

  return () => {
    document.body.removeChild(script);
  };
}, []);

  /* ── chart options ── */
  const barOpts = {
    maintainAspectRatio: false,
    animation: false,
    plugins: { legend: { labels: { color:"#94a3b8", font:{ size:12 } } } },
    scales: {
      x: { ticks:{ color:"#94a3b8" }, grid:{ color:"rgba(255,255,255,0.05)" } },
      y: { ticks:{ color:"#94a3b8", callback: v => "Rp "+Intl.NumberFormat("id-ID",{notation:"compact"}).format(v) },
           grid:{ color:"rgba(255,255,255,0.05)" } },
    },
  };
  const pieOpts = {
    maintainAspectRatio: false,
    animation: false,
    plugins: { legend: { position:"right", labels:{ color:"#94a3b8", padding:16, font:{size:11} } } },
  };

  const TABS = ["PAD","Pajak","Retribusi"];

  /* ─────────────────────────────────────────────────────────────── */
  return (
    <>
  <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700;800&family=Inter:wght@400;500;600;700;800&display=swap');

        /* ── Reset & tokens (Tema Elegan • Mewah • Premium) ── */
        *, *::before, *::after { box-sizing: border-box; margin:0; padding:0; }

        :root {
          --navy:   #070b14;                 /* Latar utama: hitam kebiruan premium */
          --navy2:  #0b1120;                 /* Latar alternatif section, sedikit lebih terang */
          --card:   #0f1729;                 /* Kartu: navy gelap dengan kesan kaca premium */
          --card2:  #16213a;                 /* Elemen sekunder / tab */
          --border: rgba(212,175,90,0.16);   /* Garis batas dengan sentuhan emas tipis */
          --gold:   #d4af37;                 /* Aksen utama: emas klasik */
          --gold-soft: #f3dfa0;              /* Emas pucat untuk highlight teks */
          --gold2:  #f6ecd4;                 /* Warna judul: krem keemasan lembut */
          --teal:   #34d399;                 /* Hijau zamrud untuk indikator positif */
          --blue:   #9db4d8;                 /* Biru kabut untuk elemen fungsional */
          --text:   #e7ebf3;                 /* Teks utama: putih gading */
          --muted:  #8b96ac;                 /* Teks pendukung: abu kebiruan lembut */
          --radius: 18px;
          --transition: .4s cubic-bezier(.4,0,.2,1);
          font-family: 'Inter', 'Segoe UI', system-ui, sans-serif;
        }

        body {
          background:
            radial-gradient(ellipse 1200px 600px at 10% -10%, rgba(212,175,55,.07), transparent 60%),
            radial-gradient(ellipse 900px 500px at 100% 20%, rgba(52,211,153,.05), transparent 55%),
            var(--navy);
          color: var(--text);
          -webkit-font-smoothing: antialiased;
        }

        h1,h2,h3, .bp-section-title { font-family: 'Playfair Display', 'Inter', serif; }

        /* ── Page fade-in ── */
        .bp-page { opacity:0; transform:translateY(14px); transition: opacity .7s ease, transform .7s ease; }
        .bp-page.mounted { opacity:1; transform:translateY(0); }

        /* ════════════ HERO ════════════ */
        .bp-hero {
          position: relative;
          height: 560px;
          overflow: hidden;
          background: #05070d;
          border-radius: var(--radius);
          box-shadow: 0 0 0 1px rgba(212,175,55,.22), 0 30px 60px -20px rgba(0,0,0,.7);
        }
        .bp-hero::after {
          content:"";
          position:absolute; inset:10px;
          border:1px solid rgba(212,175,55,.28);
          border-radius: calc(var(--radius) - 6px);
          pointer-events:none; z-index:5;
        }
        .bp-hero-track {
          display: flex;
          height: 100%;
          transition: transform .8s cubic-bezier(.77,0,.18,1);
        }
        .bp-hero-track img {
          min-width: 100%;
          height: 100%;
          object-fit: cover;
          flex-shrink: 0;
          filter: saturate(1.05) contrast(1.03);
        }
        .bp-hero-overlay {
          position: absolute; inset:0;
          background: linear-gradient(to top, rgba(5,7,13,.96) 0%, rgba(5,7,13,.45) 45%, rgba(5,7,13,.05) 100%);
        }
        /* dots */
        .bp-hero-dots {
          position: absolute; bottom:80px; left:50%; transform:translateX(-50%);
          display: flex; gap:9px; z-index:4;
        }
        .bp-hero-dots span {
          width:8px; height:8px; border-radius:50%;
          background: rgba(246,236,212,.3);
          cursor:pointer; transition: background .3s, transform .3s;
        }
        .bp-hero-dots span.active { background: var(--gold); transform: scale(1.35); box-shadow: 0 0 10px rgba(212,175,55,.7); }
        /* arrows */
        .bp-hero-arrow {
          position:absolute; top:50%; transform:translateY(-50%);
          z-index:5; background: rgba(255,255,255,.08); border:1px solid rgba(212,175,55,.3);
          color:var(--gold-soft); width:46px; height:46px; border-radius:50%;
          font-size:20px; cursor:pointer; backdrop-filter:blur(10px);
          transition: background var(--transition), border-color var(--transition), transform var(--transition);
          display:flex; align-items:center; justify-content:center;
        }
        .bp-hero-arrow:hover { background: rgba(212,175,55,.18); border-color: var(--gold); transform:translateY(-50%) scale(1.06); }
        .bp-hero-arrow.left  { left:24px; }
        .bp-hero-arrow.right { right:24px; }
        /* caption */
        .bp-hero-caption {
          position:absolute; bottom:0; left:0; right:0;
          padding: 30px 44px; z-index:4;
        }
        .bp-hero-caption p {
          font-family: 'Playfair Display', serif;
          font-size: clamp(18px, 2.8vw, 26px);
          font-weight: 700; color:#fdf6e3;
          letter-spacing:.01em;
          text-shadow: 0 4px 18px rgba(0,0,0,.55);
          max-width: 720px;
        }

        /* ════════════ MARQUEE ════════════ */
        .bp-marquee {
          background: linear-gradient(90deg, #0b1120, #151f35 50%, #0b1120);
          color: var(--gold-soft);
          font-weight: 600; font-size: 13px;
          letter-spacing: .04em; padding: 11px 0;
          border-top: 1px solid var(--border);
          border-bottom: 1px solid var(--border);
        }

        /* ════════════ SECTION WRAPPERS ════════════ */
        .bp-section { padding: 80px 0; }
        .bp-section.alt { background: var(--navy2); }
        .bp-container { max-width: 1200px; margin:0 auto; padding: 0 24px; }

        .bp-section-head {
          display:flex; align-items:center; justify-content:space-between;
          margin-bottom: 44px;
        }
        .bp-section-title {
          font-size: clamp(21px, 3vw, 30px);
          font-weight: 700; color: var(--gold2); letter-spacing:-.01em;
        }
        .bp-section-title span {
          display:inline-block;
          position: relative;
          padding-bottom: 10px;
        }
        .bp-section-title span::after {
          content:"";
          position:absolute; left:0; bottom:0;
          width:56px; height:3px; border-radius:2px;
          background: linear-gradient(90deg, var(--gold), transparent);
        }
        .bp-see-all {
          display:flex; align-items:center; gap:6px;
          color: var(--blue); font-size:13px; font-weight:600;
          letter-spacing:.02em;
          text-decoration:none; transition: gap .25s, color .25s;
        }
        .bp-see-all:hover { gap:10px; color: var(--gold-soft); }

        /* ════════════ APPS CARDS ════════════ */
        .bp-apps { display:grid; grid-template-columns:repeat(3,1fr); gap:28px; }
        @media(max-width:640px){ .bp-apps { grid-template-columns:1fr; } }
        .bp-app-card {
          background: linear-gradient(165deg, var(--card), #0b1224);
          border: 1px solid var(--border);
          border-radius: var(--radius); padding:32px 24px;
          display:flex; flex-direction:column; align-items:center; gap:16px;
          text-decoration:none; position:relative; overflow:hidden;
          transition: transform var(--transition), box-shadow var(--transition), border-color var(--transition);
          box-shadow: 0 12px 30px -10px rgba(0,0,0,.5);
        }
        .bp-app-card::before {
          content:""; position:absolute; top:0; left:0; right:0; height:2px;
          background: linear-gradient(90deg, transparent, var(--gold), transparent);
          opacity:0; transition: opacity var(--transition);
        }
        .bp-app-card:hover {
          transform: translateY(-6px);
          box-shadow: 0 20px 45px -12px rgba(212,175,55,.18);
          border-color: rgba(212,175,55,.45);
        }
        .bp-app-card:hover::before { opacity:1; }
        .bp-app-card img { height:95px; object-fit:contain; filter: brightness(1.05) drop-shadow(0 6px 14px rgba(0,0,0,.4)); }
        .bp-app-card span { font-size:12px; color:var(--muted); font-weight:700; letter-spacing:.06em; text-transform:uppercase; text-align:center; }

        /* ════════════ CHART SECTION ════════════ */
        .bp-tabs { display:flex; gap:8px; margin-bottom:30px; }
        .bp-tab {
          padding: 9px 22px; border-radius: 24px; border:1px solid var(--border);
          font-size: 13px; font-weight:600; letter-spacing:.02em; cursor:pointer;
          background: var(--card2); color:var(--muted);
          transition: background var(--transition), color var(--transition), border-color var(--transition), box-shadow var(--transition);
        }
        .bp-tab.active {
          background: linear-gradient(135deg, var(--gold), #b8912a);
          border-color: var(--gold);
          color:#0b0e16;
          box-shadow: 0 8px 20px -6px rgba(212,175,55,.5);
        }

        .bp-chart-box {
          background: linear-gradient(165deg, var(--card), #0b1224);
          border:1px solid var(--border);
          border-radius: var(--radius); padding:30px; overflow:hidden;
          box-shadow: 0 16px 36px -14px rgba(0,0,0,.55);
        }
        .bp-chart-title {
          font-family:'Playfair Display', serif;
          font-size:17px; font-weight:600; color: var(--gold-soft); margin-bottom:22px;
        }
        .bp-chart-wrap  { height:280px; margin-bottom:28px; }

        /* chart table */
        .bp-table { width:100%; border-collapse:collapse; font-size:13px; }
        .bp-table thead tr { background: rgba(212,175,55,.06); }
        .bp-table th { padding:13px 14px; text-align:left; color:var(--gold-soft); font-weight:700; font-size:11px; letter-spacing:.06em; text-transform:uppercase; }
        .bp-table td { padding:13px 14px; color:var(--text); border-top:1px solid var(--border); }
        .bp-table tbody tr:hover { background: rgba(212,175,55,.04); }
        .bp-pct { display:inline-block; padding:3px 12px; border-radius:20px; font-size:11px; font-weight:700;
          background: rgba(52,211,153,0.12); color:var(--teal); border: 1px solid rgba(52,211,153,.25); }

        /* ════════════ NEWS GRID ════════════ */
        .bp-news-grid { display:grid; grid-template-columns:repeat(4,1fr); gap:22px; }
        @media(max-width:900px){ .bp-news-grid { grid-template-columns:repeat(2,1fr); } }
        @media(max-width:540px){ .bp-news-grid { grid-template-columns:1fr; } }

        .bp-news-card {
          background: linear-gradient(165deg, var(--card), #0b1224);
          border:1px solid var(--border);
          border-radius:var(--radius); overflow:hidden;
          transition: transform var(--transition), box-shadow var(--transition), border-color var(--transition);
          display:flex; flex-direction:column;
          box-shadow: 0 12px 28px -12px rgba(0,0,0,.5);
        }
        .bp-news-card:hover { transform:translateY(-5px); box-shadow:0 20px 40px -14px rgba(212,175,55,.16); border-color: rgba(212,175,55,.4); }
        .bp-news-card img { width:100%; height:180px; object-fit:cover; display:block; filter: saturate(1.05); }
        .bp-news-card-body { padding:18px; flex:1; display:flex; flex-direction:column; gap:9px; }
        .bp-news-date { display:flex; align-items:center; gap:5px; color:var(--muted); font-size:11px; letter-spacing:.03em; }
        .bp-news-title { font-size:13px; font-weight:600; color:var(--text); line-height:1.55; text-decoration:none; }
        .bp-news-title:hover { color: var(--gold-soft); }

        /* ════════════ VIDEO ════════════ */
        .bp-video-grid { display:grid; grid-template-columns:1.6fr 1fr; gap:28px; }
        @media(max-width:768px){ .bp-video-grid { grid-template-columns:1fr; } }

        .bp-video-main { border-radius:var(--radius); overflow:hidden; background:var(--card); border:1px solid var(--border); box-shadow: 0 16px 36px -14px rgba(0,0,0,.55); }
        .bp-video-main iframe, .bp-video-main > div > iframe { width:100% !important; border-radius:var(--radius); }

        .bp-video-list { display:flex; flex-direction:column; gap:12px; }
        .bp-video-item {
          background:var(--card); border:1px solid var(--border); border-radius:12px;
          overflow:hidden; cursor:pointer; display:flex; align-items:stretch;
          transition: border-color var(--transition), box-shadow var(--transition), background var(--transition);
          box-shadow: 0 4px 14px -8px rgba(0,0,0,.5);
        }
        .bp-video-item:hover { border-color: rgba(212,175,55,.4); box-shadow:0 10px 22px -10px rgba(212,175,55,.2); background: var(--card2); }
        .bp-video-item.active { border-color: var(--gold); background: var(--card2); }
        .bp-video-thumb { position:relative; width:110px; flex-shrink:0; }
        .bp-video-thumb img { width:100%; height:100%; object-fit:cover; display:block; }
        .bp-video-thumb-overlay {
          position:absolute; inset:0; background:rgba(7,11,20,.35);
          display:flex; align-items:center; justify-content:center;
          color: var(--gold-soft); transition: background var(--transition);
        }
        .bp-video-item:hover .bp-video-thumb-overlay { background:rgba(212,175,55,.28); color:#0b0e16; }
        .bp-video-info { padding:12px; display:flex; flex-direction:column; justify-content:center; gap:4px; }
        .bp-video-info p { font-size:12px; color:var(--text); font-weight:600; line-height:1.4; }
        .bp-video-info span { font-size:11px; color:var(--muted); }

        /* ════════════ INSTAGRAM ════════════ */
        .bp-ig-wrap { background:var(--card); border:1px solid var(--border); border-radius:var(--radius); padding:30px; box-shadow: 0 16px 36px -14px rgba(0,0,0,.55); }

        /* ════════════ LINKS ════════════ */
        .bp-links-grid { display:flex; flex-wrap:wrap; gap:16px; }
        .bp-link-card {
          background:var(--card); border:1px solid var(--border); border-radius:12px;
          padding:18px 26px; display:flex; align-items:center; gap:14px;
          text-decoration:none; transition: all var(--transition);
          box-shadow: 0 8px 20px -10px rgba(0,0,0,.5);
        }
        .bp-link-card:hover { border-color: rgba(212,175,55,.4); transform:translateY(-3px); box-shadow: 0 14px 28px -12px rgba(212,175,55,.2); }
        .bp-link-card img { height:110px; object-fit:contain; }
        .bp-link-card span { font-size:13px; font-weight:600; color:var(--text); }

        /* ════════════ COUNTER ════════════ */
        .bp-counter-box {
          display:inline-flex; align-items:center; gap:16px;
          background:var(--card); border:1px solid var(--border);
          border-radius:12px; padding:18px 26px;
          box-shadow: 0 8px 20px -10px rgba(0,0,0,.5);
        }
        .bp-counter-label { font-size:13px; color:var(--muted); font-weight:500; }

        /* ════════════ STATS PILL ROW ════════════ */
        .bp-stat-row { display:flex; gap:12px; flex-wrap:wrap; margin-bottom:24px; }
        .bp-stat-pill {
          background:var(--card2); border:1px solid var(--border); border-radius:20px;
          padding:7px 16px; font-size:12px; font-weight:600; color:var(--muted);
          display:flex; align-items:center; gap:6px;
        }
        .bp-stat-pill b { color: var(--gold-soft); }
      `}</style>

      <div className={`bp-page${mounted ? " mounted" : ""}`}>
        <Header active="beranda" />

        {/* ── HERO ── */}
        <section className="bp-hero">
         <div
  className="bp-hero-track"
  style={{
    transform: `translateX(-${slideIndex * 100}%)`,
  }}
>
 {Array.isArray(banner) && banner.length > 0 ? (
  banner.map((b, i) => {
    // thumbnail sudah di-sanitasi saat fetch (secureUrl + validasi)
    const imgUrl = b?.thumbnail || hero1;
    return (
      <img
        key={i}
        src={imgUrl}
        alt={b?.judul ? b.judul.replace(/</g, "&lt;") : "banner"}
        loading={i === 0 ? "eager" : "lazy"}
        onError={(e) => {
          e.currentTarget.onerror = null;
          e.currentTarget.src = hero1;
        }}
      />
    );
  })
) : (
  [hero1, hero2].map((img, i) => (
    <img key={i} src={img} alt="default-banner" />
  ))
)}
</div>
          <div className="bp-hero-overlay" />

          <button className="bp-hero-arrow left"
            onClick={() => setSlideIndex(p => (p === 0 ? (banner.length||1)-1 : p-1))}>
            ‹
          </button>
          <button className="bp-hero-arrow right"
            onClick={() => setSlideIndex(p => (p === (banner.length||1)-1 ? 0 : p+1))}>
            ›
          </button>

          <div className="bp-hero-dots">
            {(banner.length > 0 ? banner : [0,1]).map((_, i) => (
              <span key={i} className={i === slideIndex ? "active" : ""} onClick={() => setSlideIndex(i)} />
            ))}
          </div>

          {/* link sudah divalidasi http/https saat fetch, aman dirender langsung */}
          <a
            href={banner.length > 0 ? (banner[slideIndex]?.link || "#") : "#"}
            target="_blank"
            rel="noopener noreferrer"
            className="bp-hero-caption"
          >
            <p>
              {banner.length > 0
                ? (banner[slideIndex]?.judul || "")
                : "Badan Pendapatan Daerah Kota Bekasi"}
            </p>
          </a>
        </section>

        {/* ── MARQUEE ── */}
        <div className="bp-marquee">
          <marquee direction="left">
            🏛️ Selamat datang di website Badan Pendapatan Daerah Kota Bekasi &nbsp;|&nbsp;
            Layanan prima untuk wajib pajak Kota Bekasi &nbsp;|&nbsp;
            Informasi pajak daerah tersedia di sini
          </marquee>
        </div>

        {/* ── APLIKASI ── */}
        <section className="bp-section">
          <div className="bp-container">
            <div className="bp-section-head">
              <h2 className="bp-section-title"><span>Aplikasi Layanan</span></h2>
            </div>
            <div className="bp-apps">
              {[
                { href:"https://ebphtb.bekasikota.go.id/", img:logoEbphtb, label:"e-BPHTB" },
                { href:"https://sipdah.bekasikota.go.id/", img:logoEsptpd, label:"e-SPTPD" },
                { href:"https://e-pbb.bekasikota.go.id/", img:logoPembebasan, label:"Pembebasan Pengurangan PBB-P2" },
                { href:"https://play.google.com/store/apps/details?id=com.depisista.infopbb", img:ipbb, label:"Info PBB" },
              ].map((a, i) => (
                <a key={i} href={a.href} target="_blank" rel="noreferrer" className="bp-app-card">
                  <img src={a.img} alt={a.label} />
                  <span>{a.label}</span>
                </a>
              ))}
            </div>
          </div>
        </section>

  
<section className="bp-section alt">
  <div className="bp-container">
    <div className="bp-section-head">
      <h2 className="bp-section-title">
        <span>Info Pendapatan Daerah</span>
      </h2>
    </div>

    <div className="bp-tabs">
      {TABS.map((t) => (
        <button
          key={t}
          className={`bp-tab${chartActive === t ? " active" : ""}`}
          onClick={() => setChartActive(t)}
        >
          {t}
        </button>
      ))}
    </div>

    {/* ── PAD ── */}
    {chartActive === "PAD" && (
      <div className="bp-chart-box">
        <div className="bp-chart-title">
          Target PAD Tahun {pad?.tahun || "-"}
        </div>

        <div className="bp-chart-wrap">
          <Pie
            data={{
              labels: pad?.label || [],
              datasets: [
                {
                  data: [
                    Number(pad?.pajak_daerah || 0),
                    Number(pad?.retribusi_daerah || 0),
                    Number(pad?.kd_yang_dipisahkan || 0),
                    Number(pad?.lain_lain_pad || 0),
                  ],
                  backgroundColor: [
                    "#d4af37",
                    "#34d399",
                    "#6ea8fe",
                    "#c9a8f7",
                  ],
                  borderColor: "#0b1120",
                  borderWidth: 2,
                  hoverOffset: 8,
                },
              ],
            }}
            options={pieOpts}
          />
        </div>

        <table className="bp-table">
          <thead>
            <tr>
              <th>No</th>
              <th>Keterangan</th>
              <th>Nilai</th>
            </tr>
          </thead>

          <tbody>
            {[
              ["Pajak Daerah", pad?.pajak_daerah],
              ["Retribusi Daerah", pad?.retribusi_daerah],
              ["Kekayaan Daerah Dipisahkan", pad?.kd_yang_dipisahkan],
              ["Lain-lain PAD", pad?.lain_lain_pad],
            ].map(([k, v], i) => (
              <tr key={i}>
                <td>{i + 1}</td>
                <td>{k}</td>
                <td>{formatIDR(Number(v || 0))}</td>
              </tr>
            ))}

            <tr style={{ fontWeight: 700 }}>
              <td></td>
              <td>Total PAD</td>

              <td style={{ color: "var(--gold)" }}>
                {formatIDR(
                  Number(pad?.pajak_daerah || 0) +
                    Number(pad?.retribusi_daerah || 0) +
                    Number(pad?.kd_yang_dipisahkan || 0) +
                    Number(pad?.lain_lain_pad || 0)
                )}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    )}

    {/* ── PAJAK ── */}
    {chartActive === "Pajak" && (
      <div className="bp-chart-box">
        <div className="bp-chart-title">
          Realisasi Pajak Daerah
        </div>

        <div className="bp-chart-wrap">
          <Bar
            data={{
              labels: pajak?.label || [],
              datasets: [
                {
                  label: "Target",
                  data: pajak?.target || [],
                  backgroundColor: "rgba(212,175,55,.85)",
                  borderRadius: 4,
                },
                {
                  label: "Realisasi",
                  data: pajak?.realisasi || [],
                  backgroundColor: "rgba(110,168,254,.85)",
                  borderRadius: 4,
                },
              ],
            }}
            options={barOpts}
          />
        </div>

        <table className="bp-table">
          <thead>
            <tr>
              <th>No</th>
              <th>Tahun</th>
              <th>Target</th>
              <th>Realisasi</th>
              <th>%</th>
            </tr>
          </thead>

       <tbody>
  {pajak?.all?.length ? (
    pajak.all.map((item, i) => {
      const target = Number(item?.target ?? 0);
      const realisasi = Number(item?.realisasi ?? 0);

      const pct =
        target > 0
          ? ((realisasi * 100) / target).toFixed(1)
          : "0.0";

      return (
        <tr key={i}>
          <td>{i + 1}</td>
          <td>{item?.tahun ?? "-"}</td>
          <td>{formatIDR(target)}</td>
          <td>{formatIDR(realisasi)}</td>
          <td>
            <span className="bp-pct">{pct}%</span>
          </td>
        </tr>
      );
    })
  ) : (
    <tr>
      <td colSpan="5" style={{ textAlign: "center" }}>
        Data pajak belum tersedia
      </td>
    </tr>
  )}
</tbody>
        </table>
      </div>
    )}

    {/* ── RETRIBUSI ── */}
    {chartActive === "Retribusi" && (
      <div className="bp-chart-box">
        <div className="bp-chart-title">
          Realisasi Retribusi Daerah
        </div>

        <div className="bp-chart-wrap">
          <Bar
            data={{
              labels: retribusi?.label || [],
              datasets: [
                {
                  label: "Target",
                  data: retribusi?.target || [],
                  backgroundColor: "rgba(212,175,55,.85)",
                  borderRadius: 4,
                },
                {
                  label: "Realisasi",
                  data: retribusi?.realisasi || [],
                  backgroundColor: "rgba(52,211,153,.85)",
                  borderRadius: 4,
                },
              ],
            }}
            options={barOpts}
          />
        </div>

        <table className="bp-table">
          <thead>
            <tr>
              <th>No</th>
              <th>Tahun</th>
              <th>Target</th>
              <th>Realisasi</th>
              <th>%</th>
            </tr>
          </thead>

          <tbody>
            {Array.isArray(retribusi?.all) &&
            retribusi.all.length > 0 ? (
              retribusi.all.map((item, i) => {
                const target = Number(item?.target || 0);
                const realisasi = Number(item?.realisasi || 0);

                const pct =
                  target > 0
                    ? ((realisasi * 100) / target).toFixed(1)
                    : "0.0";

                return (
                  <tr key={i}>
                    <td>{i + 1}</td>
                    <td>{item?.tahun || "-"}</td>
                    <td>{formatIDR(target)}</td>
                    <td>{formatIDR(realisasi)}</td>

                    <td>
                      <span className="bp-pct">
                        {pct}%
                      </span>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="5" style={{ textAlign: "center" }}>
                  Tidak ada data
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    )}
  </div>
</section>

{/* ── BERITA ── */}
<section className="bp-section">
  <div className="bp-container">
    <div className="bp-section-head">
      <h2 className="bp-section-title">
        <span>Berita Terkini</span>
      </h2>

      <Link to="/berita" className="bp-see-all">
        Lihat semua <IconArrow />
      </Link>
    </div>

    <div className="bp-news-grid">
      {Array.isArray(berita) && berita.length > 0 ? (
        berita.map((item) => (
          <div
            className="bp-news-card"
            key={item?.id_berita}
          >
            <img
src={
  item?.thumbnail
    ? (
        item.thumbnail.startsWith("http")
          ? item.thumbnail
          : `${BaseURL}assets/images/berita/${item.thumbnail}`
      ).replace("http://", "https://")
    : "/no-image.png"
}
alt={item?.judul || "berita"}
loading="lazy"
onError={(e) => {
  e.currentTarget.src = "/no-image.png";
}}
/>

            <div className="bp-news-card-body">
              <div className="bp-news-date">
                <IconCalendar />{" "}
                {item?.created_date || "-"}
              </div>

              <Link
                to={`/berita-detail/${item?.id_berita || ""}`}
                className="bp-news-title"
              >
                {item?.judul || "-"}
              </Link>
            </div>
          </div>
        ))
      ) : (
        <div
          style={{
            padding: "20px",
            textAlign: "center",
            width: "100%",
          }}
        >
          Tidak ada berita
        </div>
      )}
    </div>
  </div>
</section>

{/* ── AGENDA ── */}
<section className="bp-section alt">
  <div className="bp-container">
    <div className="bp-section-head">
      <h2 className="bp-section-title">
        <span>Agenda</span>
      </h2>

      <Link to="/agenda" className="bp-see-all">
        Lihat semua <IconArrow />
      </Link>
    </div>

    <div className="bp-news-grid">
      {Array.isArray(agenda) && agenda.length > 0 ? (
        agenda.map((item) => (
          <div
            className="bp-news-card"
            key={item?.id_agenda}
          >
            <img
              src={
  item?.thumbnail
    ? (
        BaseURL +
        "assets/images/agenda/" +
        item.thumbnail
      ).replace("http://", "https://")
    : "/no-image.png"
}
alt={item?.judul || "agenda"}
loading="lazy"
onError={(e) => {
  e.target.src = "/no-image.png";
}}
            />

            <div className="bp-news-card-body">
              <div className="bp-news-date">
                <IconCalendar />{" "}
                {item?.created_date || "-"}
              </div>

              <Link
                to={`/agenda-detail/${item?.id_agenda || ""}`}
                className="bp-news-title"
              >
                {item?.judul || "-"}
              </Link>
            </div>
          </div>
        ))
      ) : (
        <div
          style={{
            padding: "20px",
            textAlign: "center",
            width: "100%",
          }}
        >
          Tidak ada agenda
        </div>
      )}
    </div>
  </div>
</section>

        {/* ── VIDEO + INSTAGRAM ── */}
        <section className="bp-section">
          <div className="bp-container">
            <div className="bp-section-head">
              <h2 className="bp-section-title"><span>Berita Video</span></h2>
              <Link to="/berita-video" className="bp-see-all">Lihat semua <IconArrow /></Link>
            </div>
            <div className="bp-video-grid">
              {/* main player */}
              <div className="bp-video-main">
                {youtubePlay?.id_video && (
                  <YouTube videoId={youtubePlay.id_video} className="youtube-iframe"
                    opts={{ width:"100%", playerVars:{ autoplay:0 } }} />
                )}
              </div>
              {/* playlist */}
              <div className="bp-video-list">
                {beritaVideo.map((item, i) => (
                  <div key={item.id||i}
                    className={`bp-video-item${youtubePlay?.id_video===item.id_video?" active":""}`}
                    onClick={() => setYoutubePlay(item)}>
                    <div className="bp-video-thumb">
                      <img
  src={
    item?.thumbnail
      ? item.thumbnail.startsWith("http")
        ? item.thumbnail
        : BaseURL + "assets/images/video/" + item.thumbnail
      : `https://img.youtube.com/vi/${item?.id_video}/hqdefault.jpg`
  }
  alt={item?.judul || "video"}
  loading="lazy"
  onError={(e) => {
    e.target.src = `https://img.youtube.com/vi/${item?.id_video}/hqdefault.jpg`;
  }}
/>
                      <div className="bp-video-thumb-overlay"><IconPlay /></div>
                    </div>
                    <div className="bp-video-info">
                      <p>{item.judul}</p>
                      <span>Klik untuk putar</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Instagram */}
            <div style={{marginTop:48}}>
              <div className="bp-section-head" style={{marginBottom:24}}>
                <h2 className="bp-section-title"><span>Instagram</span></h2>
              </div>
              <div className="bp-ig-wrap">
            
<a href="https://www.instagram.com/bapenda_kotabekasi/" target="_blank">
  <img src={logoInstagram} />
</a>
              </div>
            </div>
          </div>
        </section>

        {/* ── TAUTAN ── */}
        <section className="bp-section alt">
          <div className="bp-container">
            <div className="bp-section-head">
              <h2 className="bp-section-title"><span>Link / Tautan</span></h2>
            </div>
            <div className="bp-links-grid">
              <a href="https://www.bekasikota.go.id/" target="_blank" rel="noreferrer" className="bp-link-card">
                <img src={logoBekasi} alt="Pemkot Bekasi" />
                <span>Pemerintah Kota Bekasi</span>
              </a>
              <a href="https://spse.inaproc.id/bekasikota" target="_blank" rel="noreferrer" className="bp-link-card">
                <img src={lpse} alt="LPSE" />
                <span>LPSE Kota Bekasi</span>
              </a>
             <a href="https://wbs.bekasikota.go.id/" target="_blank" rel="noreferrer" className="bp-link-card">
  <img 
    src={wbs} 
    alt="WBS"
    style={{ width: "120px", height: "auto" }}
  />
</a>
            </div>

            <div style={{ marginTop: 48 }}>
  <div
    className="bp-section-head"
    style={{ marginBottom: 16 }}
  >
    <h2 className="bp-section-title">
      <span>Total Pengunjung</span>
    </h2>
  </div>

  <div className="bp-counter-box">
   <div id="histats_counter"></div>
  </div>
</div>
          </div>
        </section>

        <SubFooter />
        <Footer />
      </div>
    </>
  );
};

export default Beranda;